module.exports = __webpack_public_path__ + "img/me.8096e4a.svg";